


export interface PatientBedModel {
  bedName: string;
  bedId: number;
  nursingStation: string;
  roomId: number;
  nursingStationId: number;
  roomName: string;
  floorId: number;
  departmentId: number;
  visitId:number
}



export class PatientBedData {
  static readonly type = '[patientBedData] patientBedData';
  constructor(public payload: PatientBedModel) {
  }
}

